import "./Common_History_Vendor.css";
import React, { useState } from "react";
import Common_Rate_Btn from "../common-rate-btn/Common_Rate_Btn";
import History_Vendor_Rate_Btn_Modal from "../../header/history/history-vendor/history-vendor-rate-btn-modal/History_Vendor_Rate_Btn_Modal";
import { IDS } from "../../../utils/IDS";

const Common_History_Vendor = ({ data }) => {
  const [showRateModal, setShowRateModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  if (!data) return null;

  const handleOpenModal = () => {
    setSelectedVendor(data);
    setShowRateModal(true);
  };
  const handleCloseModal = () => {
    setShowRateModal(false);
    setSelectedVendor(null);
  };
  return (
    <div className="history-vendor-card">
      <div className="history-vendor-header-bar">Details ID: #{data.id}</div>

      <div className="history-vendor-content">
        <div className="history-vendor-thumb">
          <img
            src={`${IDS?.IMG_URL}/${data.construction_image}`}
            alt={data?.vendor?.name}
            className="thumb-img"
          />
        </div>

        <div className="history-vendor-body">
          <div className="history-info-row">
            <span className="info-label">Vendor:</span>
            <span className="info-value">{data?.vendor?.name || "-"}</span>
          </div>

          <div className="history-info-row">
            <span className="info-label">Customer:</span>
            <span className="info-value"> {data.name}</span>
          </div>

          <div className="history-info-row">
            <span className="info-label">Material:</span>
            <span className="info-value">{data?.material?.name || "-"}</span>
          </div>

          <div className="history-info-row">
            <span className="info-label">Sub Material Category:</span>
            <span className="info-value">
              {data?.material?.sub_service?.[0]?.name || "-"}
            </span>
          </div>

          <div className="history-info-row">
            <span className="info-label">Date:</span>
            <span className="info-value">
              {new Date(data.created_at).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>

      {data?.rate_us ? (
        <div className="rated-message">⭐ You rated: {data.rate_us}</div>
      ) : (
        <Common_Rate_Btn onBtnClick={handleOpenModal} />
      )}
      <History_Vendor_Rate_Btn_Modal
        show={showRateModal}
        handleClose={handleCloseModal}
        modalId={selectedVendor?.id}
        modalType="vendor"
        modalName={selectedVendor?.vendor?.name}
        modalImg={`${IDS?.IMG_URL}/${selectedVendor?.construction_image}`}
        modalDate={selectedVendor?.created_at}
      />
    </div>
  );
};

export default Common_History_Vendor;
